import React from "react";

import { PolicyHolderList } from "@/components/features";
import { fakeI18n } from "@/i18n";
import { AppRoute, Identity, Permissions, RouteItem } from "@/shared/domain";
import { Scope } from "@/shared/hooks/useAuth/types";

const TarifficationPage = React.lazy(() => import("../components/features/ToDos/TarifficationPage/TarifficationPage"));

export const tarifficationRoutes = (user: Identity): RouteItem[] => {
    return [
        ...(user.hasGlobalPermission(Permissions.AccessTariffication)
            ? [
                  {
                      path: AppRoute.Tariffication,
                      element: <PolicyHolderList />,
                      breadcrumb: fakeI18n.t("Common.RequestAQuote"),
                      allowScopes: [Scope.Tariffication],
                      denyScopes: [Scope.Preview],
                  },
              ]
            : []),
        {
            path: AppRoute.TarifficationDetail,
            element: <TarifficationPage />,
            allowScopes: [Scope.Tariffication],
            denyScopes: [Scope.Preview],
        },
    ];
};
